import React from "react";
import ReactLoading from "react-loading";
interface LoaderProps {
  colorProp: string;
  height: string | number;
  width: string | number;
  wrapperheight: string;
}
const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
  const { colorProp, height, width, wrapperheight } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: wrapperheight,
      }}
    >
      <ReactLoading
        type={"bubbles"}
        color={"black"}
        height={height}
        width={width}
      />
    </div>
  );
};

export default Loader;
